import { Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { HowToService } from '../../services/how-to.service';
import { ChipComponent } from '../chip/chip.component';
import { NgOptimizedImage } from '@angular/common';
import { TagsSkeletonComponent } from '../tags-skeleton/tags-skeleton.component';

@Component({
  selector: 'app-tags-list',
  templateUrl: './tags-list.component.html',
  styleUrls: ['./tags-list.component.scss'],
  imports: [ChipComponent, NgOptimizedImage, TagsSkeletonComponent],
  standalone: true
})
export class TagsListComponent implements OnInit, OnDestroy {
  @ViewChild('list', { static: false }) list!: ElementRef;
  @ViewChild('listContainer', { static: false }) listContainer!: ElementRef;
  @Output() tagSelected = new EventEmitter<string>();
  tags: string[] = [];
  activeTagIndex: number | null = null;
  state: 'ready' | 'loading' = 'loading';

  private readonly scrollOffset = 100;
  private readonly subscription = new Subscription();

  constructor(private tutorialsService: HowToService) {}

  ngOnInit() {
    this.subscription.add(
      this.tutorialsService
        .getTags()
        .pipe(
          tap(response => {
            this.tags = response;
            this.state = 'ready';
          })
        )
        .subscribe()
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  onTagClick(text: string, index: number) {
    this.activeTagIndex = index;
    this.tagSelected.emit(text);
  }

  scrollLeft() {
    this.listContainer.nativeElement.scrollLeft -= this.scrollOffset;
  }

  scrollRight() {
    this.listContainer.nativeElement.scrollLeft += this.scrollOffset;
  }

  shouldDisableLeftScroll() {
    return this.listContainer ? this.listContainer.nativeElement.scrollLeft === 0 : true;
  }

  shouldDisableRightScroll() {
    if (!this.listContainer || !this.list) {
      return true;
    }
    const containerWidth = this.listContainer.nativeElement.offsetWidth;
    const contentWidth = this.list.nativeElement.scrollWidth;

    return contentWidth - this.listContainer.nativeElement.scrollLeft <= containerWidth;
  }
}
